export type ServiceOrderDetailModel = {
  codInterno: number
  numOS: number
  tipo: ServiceOrderDetailModality
  tipoOSDescricao: string
  status: ServiceOrderDetailStatus
  prioridade: ServiceOrderDetailPriority
  executar: string
  observacaoInterna: string
  obsFechamento: string
  encodeAssinatura: string
  encodeAssinaturaTecnico: string
  listaProdutos: ServiceOrderProducts[]
  listaOsServicos: ServiceOrderServices[]
  listaAtendimentos: ServiceOrderTreatments[]
  listaProdutosRetirar: ServiceOrderRemovals[]
  listaNFOS: ServiceOrderWarehouse[]
  listaProblemas: ServiceOrderProblems[]
  totalProdutos: number
  descontoProd: number
  pDesconto: number
  totalServicos: number
  descontoServ: number
  pDescontoServico: number
} & ServiceOrderClient & ServiceOrderInfo

export type ServiceOrderClient = {
  codCliente: number
  cliente: string
  fantasia: string
  cpf: string
  modalidade: string
  inscricaoEstadual: string
  fone1: string
  celular: string
  responsavel: string
  endereco: string
  bairro: string
  cidade: string
  estado: string
}

export type ServiceOrderInfo = {
  empresa: string
  orcamento: number
  nomeVendedor: string
  solicitante: string
  previsao: string
  agendada: boolean
  dataAgenda: string
  abertura: string
  causaOS: string
  defeito: string
  usuarioAbertura: string
  nomeTecnico: string
  nomeGetec: string
  veiculoOS: string
  dataFechamento: string
  solucaoOS: string
  usuarioFechamento: string
  notaLocacao: string
  dataEmissao: string
  valorCrea: number
}

export type ServiceOrderProducts = {
  codInterno: number
  codProduto: number
  descricao: string
  quantidade: number
  unitario: number
  total: number
  cobraCliente: boolean
  motivo: string
  entregue: number
}

export type ServiceOrderServices = {
  codInterno: number
  codServico: number
  descricao: string
  quantidade: number
  total: number
  unitario: number
  cobraCliente: boolean
}

export type ServiceOrderTreatments = {
  codTecnico: number
  tecnico: string
  data: string
  hrInicio: string
  hrFim: string
  hrInicioDeslocamento: string
  hrFimDeslocamento: string
  responsavel: string
  observacoes: string
}

export type ServiceOrderRemovals = {
  descricao: string
  quantidade: number
  unitario: number
  total: number
  cobraCliente: boolean
  motivo: string
  entregue: boolean
}

export type ServiceOrderWarehouse = {
  dataMovimento: string
  ocorrencia: string
  estoque: string
  nota: string
  codigo: number
  produto: string
  quantidade: number
  usuario: string
}

export type ServiceOrderProblems = {
  origem: ProblemOrigin
  dataInicial: string
  dataFinal: string
  pendencia: string
  strProblema: string
}

export enum ServiceOrderDetailStatus {
  Aberta = 'A',
  Fechada = 'B',
  Faturada = 'F'
}

export enum ServiceOrderDetailPriority {
  Alta = 'A',
  Normal = 'N',
  Baixa = 'B'
}

export enum ServiceOrderDetailModality {
  ManutencaoCorretiva = 'M',
  VendasInstalacao = 'V',
  ManutenCaoPreventiva = 'P',
  VendasAmpliacao = 'A',
  RetiradaEquipamento = 'R',
  Interna = 'I'
}

export enum ProblemOrigin {
  Empresa = 'E',
  Cliente = 'C',
}
